import { selectEntitiesCompetitors } from '../../../../selectors/entities/competitors/entitiesCompetitorsPrimary.selector';
import { selectEntitiesMatchesEntityStatus } from '../../../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { selectEntitiesOutcomes } from '../../../../selectors/entities/outcomes/entitiesOutcomesPrimary.selector';
import { makeComplexeMatchBetsSelector } from '../../../../selectors/match.selector';
import { type StateType } from '../../../../states';
import { MatchEntityStatus } from '../../../../states/entities/matches';
import { type Selector } from '../../../../types/selectors';
import { SportIds, type SportId } from '../../../../types/sports';
import { createResultEqualSelector } from '../../../../utils/reselect';
import { makeBetTypeFromFilterIdSelector } from '../../selectors/lineUp.selector';

type LineUpRaceTrackSelectorProps = {
  filterId?: string;
  matchId?: number;
  sportId?: SportId;
};

type LineUpRaceTrackPropsType = {
  competitors: Array<number>;
  numberOfColumns: number;
};

const selectLineUpRaceTrackPlayers: Selector<Array<number>> = (
  state: StateType,
  props: LineUpRaceTrackSelectorProps = {},
) => {
  const selectBetTypeFromFilterId = makeBetTypeFromFilterIdSelector();
  const selectComplexeMatchBets = makeComplexeMatchBetsSelector();

  const matchStatus = selectEntitiesMatchesEntityStatus(state, props);
  const complexeMatchBets = selectComplexeMatchBets(state, props);
  const betType = selectBetTypeFromFilterId(state, props);

  const betsArray = complexeMatchBets.map((element) => element.bet);
  const foundBets = betsArray.filter((bet) => betType === bet.betType);

  const { outcomes: betOutcomes } = foundBets[0] ?? { outcomes: [] };

  const allOutcomes = selectEntitiesOutcomes(state);

  const relatedCompetitors =
    betOutcomes.map((key) => allOutcomes[key].competitorId).filter((k): k is number => Boolean(k)) ?? [];

  const orderedCompetitors = [];
  const competitors = selectEntitiesCompetitors(state);
  const competitorsArray = relatedCompetitors.map((key) => competitors[key]) ?? [];

  for (const competitor of competitorsArray) {
    const { startingOrder, competitorId, position } = competitor ?? {};
    if (!MatchEntityStatus.isPrematch(matchStatus) && typeof position === 'number') {
      orderedCompetitors[position] = competitorId;
    } else if (typeof startingOrder === 'number') {
      orderedCompetitors[startingOrder] = competitorId;
    }
  }

  return orderedCompetitors.filter((i) => i);
};

const selectLineUpRaceTrackNumberOfColumns: Selector<number> = (
  _: StateType,
  props: LineUpRaceTrackSelectorProps = {},
) => {
  const { sportId } = props;
  if (sportId === SportIds.MOTO) {
    return 3;
  }
  return 2;
};

const selectLineUpRaceTrackProps: Selector<LineUpRaceTrackPropsType> = createResultEqualSelector(
  [selectLineUpRaceTrackPlayers, selectLineUpRaceTrackNumberOfColumns],
  (competitors, numberOfColumns) => ({
    competitors,
    numberOfColumns,
  }),
);

export default selectLineUpRaceTrackProps;
